(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hotspot-with-text"] && !Shopify.designMode) return;
  try {
    
  function initHotspotInteractionsV5_2(sectionElement) { // Renamed function to V5_2
    const sectionWrapper = sectionElement.querySelector('.hotspots-image-section-wrapper-v5');
    const isAnimationsEnabled = sectionWrapper && sectionWrapper.classList.contains('animations-enabled');

    if (isAnimationsEnabled) {
      let animationThreshold = 0.1;
      try {
        let sectionId = sectionElement.id.replace('shopify-section-', '');
        if (!sectionId && sectionElement.dataset.sectionId) {
            sectionId = sectionElement.dataset.sectionId;
        }
        if (sectionId) {
          const scriptElement = document.querySelector(`script[type="application/json"][data-section-id="${sectionId}"], #${sectionId} script[type="application/json"]`);
          if (scriptElement && scriptElement.textContent) {
            const sectionData = JSON.parse(scriptElement.textContent);
            if (sectionData && typeof sectionData.animation_threshold !== 'undefined') {
              animationThreshold = parseFloat(sectionData.animation_threshold);
            } else if (sectionData && sectionData.settings && typeof sectionData.settings.animation_threshold !== 'undefined') {
              animationThreshold = parseFloat(sectionData.settings.animation_threshold);
            } else if (Shopify && Shopify.sectionData && Shopify.sectionData[sectionId] && typeof Shopify.sectionData[sectionId].animation_threshold !== 'undefined') {
                animationThreshold = parseFloat(Shopify.sectionData[sectionId].animation_threshold);
            }
          }
        }
      } catch (e) { if (console && console.warn) console.warn(`Hotspots (Section ${sectionElement.id || 'N/A'}): Error parsing animation_threshold. Using default.`, e); }
      if (isNaN(animationThreshold) || animationThreshold < 0 || animationThreshold > 1) animationThreshold = 0.1;

      const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) entry.target.classList.add('is-visible');
        });
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(observerCallback, { root: null, rootMargin: '0px', threshold: animationThreshold });
        if (sectionWrapper) observer.observe(sectionWrapper); // Check if sectionWrapper exists
      } else {
        if (console && console.warn) console.warn(`Hotspots (Section ${sectionElement.id || 'N/A'}): IntersectionObserver not supported.`);
        if (sectionWrapper) sectionWrapper.classList.add('is-visible');
      }
    } else if (sectionWrapper) {
      sectionWrapper.style.opacity = '1';
      sectionWrapper.style.transform = 'translateY(0)';
      const hotspotAreas = sectionWrapper.querySelectorAll('.hotspot-area-v5');
      hotspotAreas.forEach(area => {
        area.style.opacity = '1';
        area.style.transform = 'scale(1) translateY(0)';
      });
    }

    // Popup trigger logic is REMOVED. Hotspot markers are now purely visual cues
    // or rely on CSS :hover for desktop text emphasis.
    // const hotspotMarkers = sectionElement.querySelectorAll('.hotspot-marker-v5');
    // hotspotMarkers.forEach(marker => {
    //   marker.addEventListener('click', function(event) {
    //     // No mobile popup action needed here anymore
    //   });
    // });

    // Popup closing logic is REMOVED.
    // const popupsContainer = sectionElement.querySelector('.hotspot-popups-global-container-v5-1');
    // if (popupsContainer) { ... }
  }

  function setupHotspotSectionsV5_2() { // Renamed
    document.querySelectorAll('.shopify-section.section-image-hotspots-v5').forEach(sectionElement => {
      if (sectionElement.querySelector('.hotspots-image-section-wrapper-v5.layout-style-split')) {
         initHotspotInteractionsV5_2(sectionElement); // Call renamed function
      }
    });
  }

  document.addEventListener('DOMContentLoaded', setupHotspotSectionsV5_2); // Call renamed function

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const sectionElement = event.target;
      if (sectionElement && sectionElement.classList && sectionElement.classList.contains('section-image-hotspots-v5') && sectionElement.querySelector('.hotspots-image-section-wrapper-v5.layout-style-split')) {
        initHotspotInteractionsV5_2(sectionElement); // Call renamed function
      }
    });
    document.addEventListener('shopify:section:reorder', function() {
        setupHotspotSectionsV5_2(); // Call renamed function
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspots"] && !Shopify.designMode) return;
  try {
    
function initHotspotGsapAnimations(sectionElement) {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        if (console && console.warn) console.warn('GSAP or ScrollTrigger is not loaded.');
        const fallbackWrapper = sectionElement.querySelector('.hotspots-image-section-wrapper-v4-9');
        if (fallbackWrapper && fallbackWrapper.classList.contains('animations-enabled')) {
            fallbackWrapper.style.opacity = '1'; fallbackWrapper.style.transform = 'translateY(0)';
            const fbis = sectionElement.querySelector('.hotspots-image-section-v4-9'); if (fbis) { fbis.style.opacity = '1'; fbis.style.transform = 'scale(1)';}
            const fbImg = sectionElement.querySelector('.hotspots-main-image-v4-9'); if (fbImg) { fbImg.style.opacity = '1'; fbImg.style.transform = 'scale(1)';}
            const fbHs = sectionElement.querySelectorAll('.hotspot-area-v4-9'); fbHs.forEach(a => { a.style.opacity = '1'; a.style.transform = 'translate(0,0) scale(1)';});
        }
        // Ensure popup JS runs even if GSAP fails
        initializeMobilePopups(sectionElement);
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const sectionWrapper = sectionElement.querySelector('.hotspots-image-section-wrapper-v4-9');
    const isAnimationsEnabled = sectionWrapper && sectionWrapper.classList.contains('animations-enabled');

    ScrollTrigger.getAll().forEach(trigger => {
        if (trigger.trigger && sectionElement.contains(trigger.trigger)) {
            trigger.kill();
        }
    });
    
    if (isAnimationsEnabled && window.innerWidth > 959) { 
        const imageSectionContainer = sectionElement.querySelector('.hotspots-image-section-v4-9');
        const mainImage = sectionElement.querySelector('.hotspots-main-image-v4-9');
        const hotspotAreas = gsap.utils.toArray(sectionElement.querySelectorAll('.hotspot-area-v4-9'));

        // 1. Section wrapper intro animation
        gsap.to(sectionWrapper, {
            opacity: 1, y: 0, ease: "power2.out", duration: 0.8, 
            scrollTrigger: { trigger: sectionWrapper, start: "top 65%", toggleActions: "play none none none" }
        });
        
        // 2. Image section container animation
        if (imageSectionContainer) {
            gsap.to(imageSectionContainer, {
                opacity: 1, scale: 1, ease: "sine.inOut", 
                scrollTrigger: { trigger: imageSectionContainer, start: "top 60%", end: "center 50%", scrub: 1.5 }
            });
        }

        // 3. Main image grow animation
        if (mainImage) {
            gsap.to(mainImage, {
                scale: 1, opacity: 1, ease: "sine.inOut", 
                scrollTrigger: { trigger: imageSectionContainer, start: "top 55%", end: "center 45%", scrub: 1.5 }
            });
        }

        // 4. Hotspots: Individual Pop In/Out Timelines - REVERTED TO THIS STYLE
        hotspotAreas.forEach((hotspot, index) => {
            // Initial state is set by CSS: opacity 0, transform with CSS vars, scale 0.75
            // GSAP will animate from that initial state.
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: hotspot,
                    start: "top bottom-=100px", // Start when hotspot's top is 100px from viewport bottom
                    end: "bottom top+=100px",   // End when hotspot's bottom is 100px above viewport top
                    scrub: 1.2,
                    // markers: {startColor: `hsl(${index * 45}, 100%, 70%)`, endColor: `hsl(${index * 45}, 100%, 85%)`, indent: index * 10}, // For debugging
                }
            });

            // Animate IN to natural CSS position (x:0, y:0 relative to its own CSS vars)
            tl.to(hotspot, {
                x: 0, // Animates translateX to 0 (from var(--animation-initial-translate-x))
                y: 0, // Animates translateY to 0 (from var(--animation-initial-translate-y))
                opacity: 1,
                scale: 1,
                ease: "power2.out",
                duration: 0.4 // Relative duration for "in" phase
            })
            // HOLD visible state
            .to(hotspot, { 
                opacity: 1, // keep it visible
                scale: 1,   // keep it scaled
                duration: 0.4 // Relative duration for "hold" phase
            })
            // Animate OUT
            .to(hotspot, {
                opacity: 0,
                scale: 0.75,
                // To move it back to its origin:
                // x: () => getComputedStyle(hotspot).getPropertyValue('--animation-initial-translate-x').trim(),
                // y: () => getComputedStyle(hotspot).getPropertyValue('--animation-initial-translate-y').trim(),
                ease: "power1.in",
                duration: 0.4 // Relative duration for "out" phase
            });
        });

    } else { // Fallback if animations are disabled OR on mobile
        if (sectionWrapper) {
            sectionWrapper.style.opacity = '1'; sectionWrapper.style.transform = 'translateY(0)';
        }
        const isc = sectionElement.querySelector('.hotspots-image-section-v4-9'); if(isc){ isc.style.opacity = '1'; isc.style.transform = 'scale(1)'; }
        const mi = sectionElement.querySelector('.hotspots-main-image-v4-9'); if(mi){ mi.style.opacity = '1'; mi.style.transform = 'scale(1)'; }
        const ha = sectionElement.querySelectorAll('.hotspot-area-v4-9'); 
        ha.forEach(area => { 
            area.style.opacity = '1'; 
            area.style.transform = 'translate(0,0) scale(1)'; 
        });
        if (window.innerWidth <= 959) { // Ensure desktop lines/text are hidden on mobile in fallback
            ha.forEach(area => {
                const line = area.querySelector('.hotspot-line-v4-9');
                const textContent = area.querySelector('.hotspot-text-content-v4-9');
                if (line) line.style.display = 'none';
                if (textContent) textContent.style.display = 'none';
            });
        }
    }

    // --- Initialize Mobile Popups (runs regardless of GSAP desktop animations) ---
    initializeMobilePopups(sectionElement);

} // End of initHotspotGsapAnimations

function initializeMobilePopups(sectionElement) {
    const hotspotMarkers = sectionElement.querySelectorAll('.hotspot-marker-v4-9');
    hotspotMarkers.forEach(marker => {
      marker.addEventListener('click', function(event) {
        if (window.innerWidth <= 959) { 
          event.preventDefault(); 
          const popupTargetId = this.dataset.popupTarget;
          if (popupTargetId) { 
            const popup = document.querySelector(popupTargetId); // Use document.querySelector for global popups
            if (popup) { 
              popup.removeAttribute('hidden'); 
              popup.classList.add('active'); 
              document.body.classList.add('hotspot-popup-active');
            }
          }
        }
      });
    });

    // Use document.querySelectorAll for popups as they are now globally placed
    const popups = document.querySelectorAll('.hotspot-popups-global-container-v5-1 .hotspot-popup-v4-9');
    popups.forEach(popup => {
      // Ensure this popup belongs to the current section if multiple hotspot sections exist on a page,
      // or ensure IDs are globally unique. The current popup ID structure includes section.id.
      const closeButton = popup.querySelector('.hotspot-popup-close-v4-9'); 
      const overlay = popup.querySelector('.hotspot-popup-overlay-v4-9');
      function closePopup() { 
        popup.classList.remove('active'); 
        setTimeout(() => { 
            if (!popup.classList.contains('active')) popup.setAttribute('hidden', true);
        }, 350); // Match CSS transition
        document.body.classList.remove('hotspot-popup-active');
      }
      if (closeButton) {
        // Remove old listener if any from previous loads (Shopify theme editor)
        closeButton.replaceWith(closeButton.cloneNode(true)); // Simple way to remove listeners
        popup.querySelector('.hotspot-popup-close-v4-9').addEventListener('click', closePopup);
      }
      if (overlay) {
        overlay.replaceWith(overlay.cloneNode(true));
        popup.querySelector('.hotspot-popup-overlay-v4-9').addEventListener('click', closePopup);
      }
    });
}


function setupAllHotspotSectionsWithGsap() {
    document.querySelectorAll('.shopify-section.section-image-hotspots-v4-9').forEach(sectionElement => {
        initHotspotGsapAnimations(sectionElement);
    });
}

document.addEventListener('DOMContentLoaded', setupAllHotspotSectionsWithGsap);

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
        const sectionElement = event.target;
        if (sectionElement && sectionElement.classList.contains('section-image-hotspots-v4-9')) {
            initHotspotGsapAnimations(sectionElement); 
        }
    });
    document.addEventListener('shopify:section:reorder', function() { 
        if(typeof ScrollTrigger !== 'undefined') {
            ScrollTrigger.getAll().forEach(st => st.kill()); // Kill all before refresh might be safer
            ScrollTrigger.refresh(); 
        }
        setupAllHotspotSectionsWithGsap(); // Re-init all after reorder
    });
    document.addEventListener('shopify:section:select', () => { if(typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh(); });
    document.addEventListener('shopify:section:deselect', () => { if(typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh(); });
}

  } catch(e) { console.error(e); }
})();
})();
